import { render } from "./FacebookOverview.vue?vue&type=template&id=c763bb92&scoped=true"
import script from "./FacebookOverview.vue?vue&type=script&lang=js"
export * from "./FacebookOverview.vue?vue&type=script&lang=js"

import "./FacebookOverview.vue?vue&type=style&index=0&id=c763bb92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c763bb92"]])

export default __exports__